/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBlurbTradeRequestAppointment_item = {
    readonly isArt: boolean | null;
    readonly isFurniture: boolean | null;
    readonly address: {
        readonly itemAddress: string | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRequestAppointmentModalLoader_item">;
    readonly " $refType": "PdpSharedBlurbTradeRequestAppointment_item";
};
export type PdpSharedBlurbTradeRequestAppointment_item$data = PdpSharedBlurbTradeRequestAppointment_item;
export type PdpSharedBlurbTradeRequestAppointment_item$key = {
    readonly " $data"?: PdpSharedBlurbTradeRequestAppointment_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBlurbTradeRequestAppointment_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedBlurbTradeRequestAppointment_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isArt",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isFurniture",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "address",
      "storageKey": null,
      "args": null,
      "concreteType": "Address",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": "itemAddress",
          "name": "displayCityStateCountry",
          "args": [
            {
              "kind": "Literal",
              "name": "fullCountryName",
              "value": true
            }
          ],
          "storageKey": "displayCityStateCountry(fullCountryName:true)"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRequestAppointmentModalLoader_item",
      "args": null
    }
  ]
};
(node as any).hash = 'd64d21f81f260d4e35df3c471ea59712';
export default node;
